<template>
  <div
    :class="$style.banner"
    :style="bannerStyle"
    data-qa-id="inactive-families-banner"
  >
    <button
      v-if="showCloseIcon"
      type="button"
      :class="$style.closeButton"
      data-qa-id="inactive-banner-close-btn"
      @click="$emit('close')"
    >
      <MdIconClose color="spirits--700" size="sm" />
    </button>

    <div :class="$style.bannerContent">
      <div :class="$style.textSection">
        <MdTypography
          v-bind="{ tag: 'h3', variant: 'heading5--bold', color: 'black' }"
        >
          {{ $t('components.navigation.success.inactive_families_banner.title') }}
        </MdTypography>

        <div :class="$style.description">
          <MdTypography
            v-bind="{ tag: 'span', variant: 'body2--regular', color: 'spirits--700' }"
          >
            {{ descriptionPrefix }}
          </MdTypography>
          <MdTypography
            v-bind="{ tag: 'span', variant: 'body2--bold', color: 'black' }"
          >
            {{ inactiveFamilyCount }}
          </MdTypography>
          <MdTypography
            v-bind="{ tag: 'span', variant: 'body2--regular', color: 'spirits--700' }"
          >
            {{ descriptionSuffix }}
          </MdTypography>
        </div>
      </div>

      <div :class="$style.actions">
        <MdButton
          size="medium"
          variant="none"
          color="blue"
          type="button"
          data-qa-id="re-release-all-btn"
          :disabled="loading"
          @handleclick="$emit('re-release-all')"
        >
          <AnimationProcessing v-if="loading" fill="new-blue" :customStyle="true" :class="$style.btnSpinner" />
          {{ $t('components.navigation.success.inactive_families_banner.re_release_all') }}
        </MdButton>

        <MdButton
          size="medium"
          variant="bordered"
          color="blue"
          type="button"
          data-qa-id="review-inventory-btn"
          @handleclick="$emit('review-inventory')"
        >
          {{ $t('components.navigation.success.inactive_families_banner.review_inventory') }}
        </MdButton>
      </div>
    </div>

    <div :class="$style.illustrationWrapper">
      <img
        :src="illustrationSrc"
        alt=""
        :class="$style.illustrationImg"
      />
    </div>
  </div>
</template>

<script>
import { MdTypography, MdButton, MdIconClose } from '@antiqua-dls/vue-components'
import AnimationProcessing from 'components/animations/processing'
import illustrationSrc from 'src/pages/success/assets/feature-policies-illustration.svg'

export default {
  name: 'InactiveFamiliesBanner',

  components: {
    MdTypography,
    MdButton,
    MdIconClose,
    AnimationProcessing
  },

  props: {
    inactiveFamilyCount: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    showCloseIcon: {
      type: Boolean,
      default: true
    }
  },

  emits: ['re-release-all', 'review-inventory', 'close'],

  data () {
    return {
      illustrationSrc
    }
  },

  computed: {
    bannerStyle () {
      if (!this.height) return {}
      return { height: `${this.height}px`, padding: '24px' }
    },
    descriptionPrefix () {
      return this.$t('components.navigation.success.inactive_families_banner.description_prefix')
    },
    descriptionSuffix () {
      return this.$t('components.navigation.success.inactive_families_banner.description_suffix')
    }
  }
}
</script>

<style src="./inactive-families-banner.scss" lang="scss" module />
